import { LiveChannel } from '@/types/Broadcast';
import { LiveEvent } from '@/types/Live';

export function isLiveEventEntity(e: Entity): e is LiveEvent | LiveChannel {
  return 'liveSourceType' in e || 'activeEventId' in e;
}
